import React, { useEffect, useState } from "react";
import Backend from "../../../../../Backend/Backend";
import toast from "react-hot-toast";
const backend = await new Backend().init();
export default function Standing(props) {
  const symbol_id = props.symbol_id;

  const [loading, setLoading] = useState(true);
  const [standing, setStanding] = useState("");

  useEffect(() => {
    loadStanding();
  }, []);

  const loadStanding = () => {
    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      symbol_id: symbol_id,
    };

    backend.symbol_standing(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        setStanding(r.standing);
      } else {
        toast.error(r.message);
      }
    });
  };

  return standing.length > 0 ? (
    <div className="standingQty">
      <div className={"symbolRatePos"}>
        POSITION RATE : {loading ? 0 : parseFloat(standing[0].rate).toFixed(0)}{" "}
        {" ₹"}
      </div>
      <div className={"symbolQtyPos"}>
        QTY : {loading ? 0 : parseFloat(standing[0].qty).toFixed(0)}
      </div>
      <div
        className={`symbolQtyPos ${
          loading ? 0 : standing[0].buy_sell == 0 ? "buytext" : "selltext"
        } `}
      >
        TYPE : {loading ? 0 : standing[0].buy_sell == 0 ? " BUY " : " SELL "}
      </div>
    </div>
  ) : null;
}
